/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_BenchmarkInputs */

const en_mk_foot_benchmark = /** @type {(inputs: Mk_Foot_BenchmarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmark`)
};

const id_mk_foot_benchmark = /** @type {(inputs: Mk_Foot_BenchmarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmark`)
};

/**
* | output |
* | --- |
* | "Benchmark" |
*
* @param {Mk_Foot_BenchmarkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_benchmark = /** @type {((inputs?: Mk_Foot_BenchmarkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_BenchmarkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_benchmark(inputs)
	return en_mk_foot_benchmark(inputs)
});